import type { Comic } from '@/mocks/comics';

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <article className="group flex flex-col rounded-2xl overflow-hidden bg-background-100 border border-background-200 hover:border-primary-200 transition-all hover:-translate-y-1">
      <div className="relative aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={comic.cover}
          alt={`${comic.title}漫画封面`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute top-2.5 left-2.5 px-2.5 py-1 rounded-full text-xs font-medium text-background-50 ${
            comic.status === '已完结' ? 'bg-secondary-500' : 'bg-primary-500'
          }`}
        >
          {comic.status}
        </span>
        <div className="absolute inset-x-0 bottom-0 px-3 py-2 flex items-center justify-between bg-gradient-to-t from-black/60 to-transparent text-background-50 text-xs">
          <span>
            <i className="ri-eye-line mr-1"></i>
            {comic.views}
          </span>
          <span className="font-medium">
            <i className="ri-star-fill text-accent-400 mr-1"></i>
            {comic.rating}
          </span>
        </div>
      </div>
      <div className="flex flex-col p-3 md:p-4 flex-1">
        <h3 className="font-medium text-foreground-950 text-sm md:text-base truncate">{comic.title}</h3>
        <p className="mt-1 text-xs text-foreground-600 truncate">{comic.author} · {comic.chapters}话</p>
        <div className="mt-2.5 flex flex-wrap gap-1.5">
          {comic.tags.map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800 text-[11px] whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}